import React from "react";
import "./footer.css";
import facebook from "../../assets/images/facebook.png";
import twitter from"../../assets/images/twitter.png";
import instagram from "../../assets/images/instagram.png";
import pinterest from "../../assets/images/pinterest.png";
import snapchat from "../../assets/images/snapchat.png";
import youtube from "../../assets/images/youtube.png";
import { useTranslation } from "react-multi-lang";
import logo from "../../assets/images/Wordmark.svg";
const Footer = ({  }) => {
  const t = useTranslation();
  let locale='en-gb'

  return (
    <div id="footer_background">
      <div id="footer_wrapper">
        <div id="footer">
          <div className="footer_box">
            <h3>
              <a
                href={`http://www.montblanc.com/${locale}/discover/about-montblanc.html`}
              >
                {t("footer.About")}
              </a>
            </h3>
            <hr />
            <div className="footer_element">
              <a
                href={`http://www.montblanc.com/${locale}/discover/about-montblanc/about-us.html`}
              >
                {t("footer.Company")}
              </a>
            </div>
            <div className="footer_element">
              <a
                href={`http://www.montblanc.com/${locale}/customer-service/get-in-contact.html`}
              >
                {t("footer.Contact")}
              </a>
            </div>
            <div className="footer_element">
              <a
                href={`http://www.montblanc.com/${locale}/customer-service.html`}
              >
                {t("footer.CustomerService")}
              </a>
            </div>
            <div className="footer_element">
              <a
                href={`http://www.montblanc.com/${locale}/terms-and-legal/website-terms-of-use.html`}
              >
                {t("footer.Terms")}
              </a>
            </div>
            <div className="footer_element">
              <a
                href={`http://www.montblanc.com/${locale}/terms-and-legal/imprint.html`}
              >
                {t("footer.Imprint")}
              </a>
            </div>
          </div>
          <div className="footer_box">
            <h3> {t("footer.Follow")}</h3>
            <hr />
            <a
              id="facebook"
              className="social_icon"
              href="https://www.facebook.com/montblanc"
            >
              <img src={facebook} alt="" />
            </a>
            <a
              id="twitter"
              className="social_icon"
              href="https://twitter.com/montblanc_world"
            >
              <img src={twitter} alt="" />
            </a>
            <a
              id="pinterest"
              className="social_icon"
              href="http://www.pinterest.com/montblanc/"
            >
              <img src={pinterest} alt="" />
            </a>
            <a
              id="youtube"
              className="social_icon"
              href="https://www.youtube.com/user/montblanc"
            >
              <img src={youtube} alt="" />
            </a>
            <a
              id="instagram"
              className="social_icon"
              href="https://www.instagram.com/montblanc/"
            >
              <img src={instagram} alt="" />
            </a>
            <a
              id="snapchat"
              className="social_icon"
              href="https://www.snapchat.com/add/montblancworld"
            >
              <img src={snapchat} alt="" />
            </a>
            <div style={{ clear: "both", height: 10 }}></div>
            <div className="footer_element">
              <a href="https://itunes.apple.com/gb/artist/montblanc-international-gmbh/id379053721">
                {t("footer.Name")}
              </a>
            </div>
          </div>
          <div className="footer_box newsletterbox">
            <form
              className="newsletterform"
              action="http://www.montblanc.com/en-gb/account/newsletter-register.html"
              data-trackable-cache="true"
              data-tracking-event="newsletterform"
            >
              <fieldset>
                <input
                  name="event"
                  value="newsletterfooter"
                  disabled=""
                  type="hidden"
                />
                <input
                  name="email"
                  id="email_addr"
                  className=""
                  placeholder={t("footer.JoinPlaceholder")}
                  type="text"
                />
                <button className="icon-arrow">
                  <span className="hide">{t("footer.Submit")}</span>
                </button>
              </fieldset>
            </form>
          </div>
          <div className="footer_spacer">
            <div className="footer_asterix"></div>
            <hr />
          </div>
          <div id="footer_center">
              <img src={logo} alt="" style={{ width: 80 }} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
